import { render, staticRenderFns } from "./LifeDetail.vue?vue&type=template&id=09a7c3fe&scoped=true"
import script from "./LifeDetail.vue?vue&type=script&lang=js"
export * from "./LifeDetail.vue?vue&type=script&lang=js"
import style0 from "./LifeDetail.vue?vue&type=style&index=0&id=09a7c3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7c3fe",
  null
  
)

export default component.exports